<div class="row row-20" id="leftCont-rightNav">
  <section
    class="col-xs-12 col-sm-12 left-section Registration-nav-section"
    style="min-height: 165px"
    >
    <div
      class="col-xs-12 col-sm-12 col-md-12 Registration-split recovery-split"
      >
      <h3 class="pdp-title">Reset password</h3>
      <br />
      <br />
      <script>
        var isAnonymous = true;
      </script>

      <form
        id="salesAgentUserSearchForm"
        action="navigateToSalesAgentResetPassword()"
        method="GET"
        >
        <div class="headSearch-holder">
          <div class="input-group header-SearchBar">
            <input
              id="userResetPasswordSearch"
              name="searchText"
              placeholder="search by first name, last name, username and email-id"
              type="text"
              class="form-control"
              value=""
              autocomplete="off"
              data-di-id="#userResetPasswordSearch"
              [(ngModel)]="userEmailId"
              (ngModelChange)="validateText()"
              /><span class="input-group-btn">
              <button
                class="subBtn btn btn-default"
                type="submit"
                (click)="getUsersData()"
                [disabled]="searchDisabled"
                >
              <span class="passwordResetSearchIcon"></span>
            </button>
          </span>
        </div>
      </div>
    </form>
    <br />
    <br />
    <br />
    <div class="row">
      <div class="col-md-12 tablemain-padding">
        <form
          id="salesAgentResetPasswordForm"
          action="navigateToRstPswdEmail()"
          method="POST"
          >
          @if (isNoResults) {
            <p class="no-records">No records found.</p>
          }
          @if (!isNoResults && userAgentList.length > 0) {
            <table
              class="display pt-history pthistoryView salesAgentResetPwdTable"
              style="width: 100%"
              >
              <thead>
                <tr class="heading">
                  <th id="table1col1" class="date-new no-sort">Select</th>
                  <th id="table1col2" class="date-new no-sort">First name</th>
                  <th id="table1col3" class="date-new no-sort">Last name</th>
                  <th id="table1col4" class="date-new no-sort">User name</th>
                  <th id="table1col5" class="date-new no-sort">Email id</th>
                </tr>
              </thead>
              @for (data of userAgentList; track data; let i = $index) {
                <tbody
                  class="datatable-row"
                  >
                  <tr>
                    <td headers="table1col1">
                      <div class="radio_grp">
                        <input
                          id="uid1"
                          name="uid"
                          class="salesAgentRadio"
                          type="radio"
                          value="s1vsh77"
                          data-di-id="#uid1"
                          (click)="radioSelected(data)"
                          />
                      </div>
                    </td>
                    <td headers="table1col2">{{ data.firstName }}</td>
                    <td headers="table1col3">{{ data.firstName }}</td>
                    <td headers="table1col4">{{ data.name }}</td>
                    <td headers="table1col5">{{ data.email }}</td>
                  </tr>
                </tbody>
              }
            </table>
          }
          @if (!isNoResults && userAgentList.length > 0) {
            <table
              _ngcontent-serverapp-c280=""
              aria-describedby="ordersTable"
              id="usersList"
              class="credits-table table table-striped"
              >
              @for (data of userAgentList; track data; let i = $index) {
                <tr
                  _ngcontent-serverapp-c280=""
                  >
                  <td _ngcontent-serverapp-c280="" class="two-column-lay header">
                    Select
                  </td>
                  <td _ngcontent-serverapp-c280="" class="two-column-lay">
                    <div class="radio_grp">
                      <input
                        id="uid1"
                        name="uid"
                        class="salesAgentRadio"
                        type="radio"
                        value="s1vsh77"
                        data-di-id="#uid1"
                        (click)="radioSelected(data)"
                        />
                    </div>
                  </td>
                  <td _ngcontent-serverapp-c280="" class="two-column-lay header">
                    First name
                  </td>
                  <td _ngcontent-serverapp-c280="" class="two-column-lay">
                    {{ data.firstName }}
                  </td>
                  <td _ngcontent-serverapp-c280="" class="two-column-lay header">
                    Last name
                  </td>
                  <td _ngcontent-serverapp-c280="" class="two-column-lay">
                    {{ data.firstName }}
                  </td>
                  <td _ngcontent-serverapp-c280="" class="two-column-lay header">
                    User name
                  </td>
                  <td _ngcontent-serverapp-c280="" class="two-column-lay">
                    {{ data.name }}
                  </td>
                  <td _ngcontent-serverapp-c280="" class="two-column-lay header">
                    Email id
                  </td>
                  <td
                    _ngcontent-serverapp-c280=""
                    class="two-column-lay status-txt"
                    >
                    {{ data.email }}
                  </td>
                </tr>
              }
              <tr _ngcontent-serverapp-c280=""></tr>
            </table>
          }

          <div class="Fields-btn-group">
            @if (!isNoResults && userAgentList.length > 0) {
              <button
                class="blue-button salesAgentResetBtn"
                type="submit"
                [disabled]="isDisabled"
                (click)="resetPassword()"
                >
                Reset password
              </button>
            }
          </div>
          <div>
            <input
              type="hidden"
              name="CSRFToken"
              value="ca261ef3-5eb3-4257-a20e-b4f8a9735120"
              />
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
</div>
